<div class="c-modal-header">
  <h2 class="c-modal-title">Bid Results</h2>
  <button class="c-modal-close" (click)="closeModal()"></button>
</div>

<muni-shared-mini-card-header *ngIf="context.deal" [deal]="context.deal" [isModal]="true"
  class="gameday-mini-card__header">
</muni-shared-mini-card-header>

<div [attr.data-automation-e2e-selector]="'muni-bid-results-modal'" class="muni-bid-results-modal-body">
  <div class="c-d-flex c-flex-column" *ngIf="bidResults$ | async as bidResults">

    <!-- Series selector — visible only for multi-series deals -->
    <div *ngIf="isMultiSeries$ | async" class="bid-results-series-selector">
      <label class="bid-results-series-label">Series:</label>
      <select class="bid-results-series-select" (change)="onSeriesChange($any($event.target).value)">
        <option *ngFor="let opt of seriesOptions" [value]="opt.id">{{ opt.label }}</option>
      </select>
    </div>

    <!--
      Single unified table for all views.
      selectedSeriesId$ drives which nic/tic values are shown per row via getSeriesValue().
      Combined ('combined') → bid.nic / bid.tic (overall values).
      Series selected  → bid.series[n].nic / bid.series[n].tic for each bidder.
    -->
    <ng-container *ngIf="selectedSeriesId$ | async as seriesId">
      <table class="c-table">
        <thead>
          <tr>
            <th>Dealer Name</th>
            <th *ngIf="hasParColumn$ | async" class="c-text-right" width="110">Par</th>
            <!-- Winning award type: bold, positioned left of the pair -->
            <th class="c-text-right bid-results-winning-col" width="110">{{ bidResults.bidType }} (%)</th>
            <!-- Alternate type: positioned right -->
            <th class="c-text-right" width="110">{{ altType }} (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let bid of displayedBids">
            <td class="c-d-flex c-justify-space-between">
              <span>{{ bid.shortName || bid.name }}</span>
            </td>
            <td *ngIf="hasParColumn$ | async" class="c-text-right">
              {{ bid.parAmount | number: '1.0' }}
            </td>
            <!-- winning type value (left column, bold to match header) -->
            <td class="c-text-right bid-results-winning-col">
              {{ getSeriesValue(bid, seriesId, winningTypeKey) | number: '1.6' }}
            </td>
            <!-- alternate type value (right column) -->
            <td class="c-text-right">
              {{ getSeriesValue(bid, seriesId, altTypeKey) | number: '1.6' }}
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>

  </div>
</div>